import { Tab } from "@/types";
import React, { useEffect, useRef, useState } from "react";
import styles from './css/GeneralTab.module.css';


interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (key: string) => void;
  underlineClassName?: string;
}

const GeneralTab: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange, underlineClassName }) => {
  const [underlineWidth, setUnderlineWidth] = useState(0);
  const activeTabRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (activeTabRef.current) {
      setUnderlineWidth(activeTabRef.current.offsetWidth);
    }
  }, [activeTab]);

  return (
    <div className={styles.tabContainer}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          className={`${styles.tabItem}`}
          onClick={() => onTabChange(tab.key)}
        >
          <div
            ref={activeTab === tab.key ? activeTabRef : null}
            className={`${styles.tabText} ${
              activeTab === tab.key ? styles.activeTabText : styles.inactiveTabText
            }`}
          >
            {tab.name}
          </div>
          {activeTab === tab.key && (
            <div
              className={`${styles.underline} ${underlineClassName}`}
              style={{ 
                width: `${underlineWidth + 20}px`,
                left: `calc(50% - ${(underlineWidth + 20) / 2}px)`
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default GeneralTab;
